import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Media extends Model<Schemas['media'], Models> {
    get isVideo(): boolean {
        return this.mimeType.startsWith('video/');
    }
}

export type RenderableMedia = Pick<
    Media,
    'id' | 'url' | 'thumbUrl' | 'isVideo' | 'isGraphic' | 'width' | 'height'
>;
